// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + ({"143":"app","736":"vendor"}[chunkId] || chunkId) + "." + {"143":"8c5b220b","232":"e9987177","589":"01218b42","736":"12ebf4ef","887":"71320e54"}[chunkId] + ".css";
};